export type CosignStatus = 
  | "initiated"
  | "pending"
  | "approved"
  | "denied"
  | "expired"
  | "canceled";

export interface ApplicationCosign {
  id: number;
  application: number;
  attachment: number | null;
  cosign_uuid: string;
  status: CosignStatus;
  display_status: null | string;
  created_at: string;
  updated_at: string;
}

export interface CosignApplicationDetail extends ApplicationCosign {
  cosign_api_data?: {
    id: string;
    status: string;
    created_at: string;
    updated_at: string;
    [key: string]: any;
  };
}

export interface CreateCosignApplicationRequest {
  applicationId: string | number;
}

export interface GetCosignApplicationsRequest {
  applicationId: string | number;
}

export interface DownloadApprovalLetterRequest {
  cosignUuid: string;
}

export interface CosignInvitationEligibility {
  eligible: boolean;
  reasons: string[];
}

export const VERO1_COSIGN_HOLD_REASON = "vero1_review_not_submitted";


